import React from 'react';
import { Card, Flex } from 'antd';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import 'highcharts/highcharts-more';
import 'highcharts/modules/solid-gauge';
import { numberFormatter } from 'shared/utils/numbers/formatter';
import { ringsInsightsHighchartsOptions } from 'components/insights/rings-insights/rings-insights-highcharts-options';
import type { IRingsInsightsProps } from 'components/insights/rings-insights/types';
import styles from './rings-insights.module.scss';

export const RingsInsights: React.FC<IRingsInsightsProps> = (props) => {
  const { title, moneyValue, ldmValue, moneyGoal, ldmGoal, moneyPercent, ldmPercent } = props;

  const options = ringsInsightsHighchartsOptions(moneyPercent, ldmPercent);

  return (
    <Card title={title}>
      <Flex>
        <div className={styles.chartBox}>
          <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
        <Flex justify='center' vertical>
          <div className={styles.moneyBox}>
            <h2 className={styles.moneyLabel}>Money</h2>
            <p className={styles.infoValue}>
              {numberFormatter(moneyValue)} / {numberFormatter(moneyGoal)} €
            </p>
          </div>
          <div>
            <h2 className={styles.ldmLabel}>LDM</h2>
            <p className={styles.infoValue}>
              {numberFormatter(ldmValue)} / {numberFormatter(ldmGoal)} m.
            </p>
          </div>
        </Flex>
      </Flex>
    </Card>
  );
};
